import React from 'react';
import * as R from 'ramda';
import {present} from '@/util';
import {useTranslation} from 'react-i18next';

import BreakDownChart from '@/b2c/PlanDetail/Detail/BreakDownChart';

const showDisclaimer5 = R.ifElse(
  R.equals('afs'),
  R.always(true),
  R.always(false)
);

const Portfolio = ({currentPlan: {companyName, portfolio, siteCode}}) => {
  const {t: tr} = useTranslation('statements');

  return (
    <>
      {present(portfolio) && (
        <BreakDownChart type='portfolio' data={portfolio} />
      )}
      <section className='note'>
        <p className='desc'>{tr('disclaimer_2')}</p>
        <p className='desc'>{tr('disclaimer_3', {companyName})}</p>
        <p className='desc'>{tr('disclaimer_4')}</p>
        {showDisclaimer5(siteCode) && (
          <p className='desc'>{tr('disclaimer_5', {companyName})}</p>
        )}
      </section>
    </>
  );
};

export default Portfolio;
